import { boolean, number, string, struct } from 'io-ts/Decoder';

export const Image = struct({
	url: string,
	urlExpiryAt: number,
	exists: boolean,
});
